import { render, staticRenderFns } from "./AddPublishedCanteenWidget.vue?vue&type=template&id=26e47ee9&scoped=true&"
import script from "./AddPublishedCanteenWidget.vue?vue&type=script&lang=js&"
export * from "./AddPublishedCanteenWidget.vue?vue&type=script&lang=js&"
import style0 from "./AddPublishedCanteenWidget.vue?vue&type=style&index=0&id=26e47ee9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e47ee9",
  null
  
)

export default component.exports